import { LoaderFunctionArgs } from 'react-router-dom'
import { SharedSlice } from 'src/components/slice'
import { StateCreator } from 'zustand'
import useStockStore from '../../../store'
import { convertOrderTemplateToPurchaseOrderUi } from '../helpers/helper'

export interface EditOrderTemplatesSlice extends EditOrderTemplatesState {
  resetEditOrderTemplatesSlice: () => void

  initializeOrderTemplateData: (
    LoaderFunctionArgs: LoaderFunctionArgs
  ) => Promise<void>
}

interface EditOrderTemplatesState {}

const initialEditOrderTemplatesState: EditOrderTemplatesState = {}

export const orderTemplateSlice: StateCreator<
  EditOrderTemplatesSlice & SharedSlice,
  [],
  [],
  EditOrderTemplatesSlice
> = (set) => ({
  ...initialEditOrderTemplatesState,

  resetEditOrderTemplatesSlice: () => set(initialEditOrderTemplatesState),

  initializeOrderTemplateData: async ({ params }) => {
    const { getOrderTemplate } = useStockStore.getState()

    const orderTemplateId = params.templateId

    if (!orderTemplateId) return

    const orderTemplate = await getOrderTemplate(orderTemplateId)

    if (!orderTemplate) return

    const { setPurchaseOrderUi, items, salesTax } = useStockStore.getState()
    const purchaseOrderUi = convertOrderTemplateToPurchaseOrderUi(
      orderTemplate,
      items,
      salesTax
    )

    setPurchaseOrderUi(purchaseOrderUi)
  },
})

export default orderTemplateSlice
